import { Package } from '__generated__/Package';
import { StructuredBriefFieldsInput } from '__generated__/types';
import { Color } from 'projects/consts';
import React from 'react';

interface BriefContext {
    brief: {
        id: string;
        designers: { id: number }[];
        designersWithSource: { source: string }[];
    };
    package?: Package | null;
    themeColor?: Color;
    themeName?: string;
    schema?: keyof StructuredBriefFieldsInput;
    totalAllowableDesigners: number;
    disableContacts: boolean;
}

const Context = React.createContext<BriefContext>({
    brief: { id: '12341234', designers: [], designersWithSource: [] },
    totalAllowableDesigners: 5,
    disableContacts: false,
});

export default Context;
